import React, { useState } from "react";

interface UserListProps {
  users: any[];

  handleDeleteUser: (index: string) => void;
}

const UserList: React.FC<UserListProps> = ({ users, handleDeleteUser }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<string | null>(null);

  const confirmDelete = (index: string) => {
    setSelectedIndex(index);
    setShowModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedIndex !== null) {
      handleDeleteUser(selectedIndex);
    }
    setShowModal(false);
    setSelectedIndex(null);
  };

  const safeUsers = Array.isArray(users) ? users : [];

  return (
    <>
      <div className="table-responsive">
        <table className="table table-hover table-striped table-bordered align-middle ">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {safeUsers.map((user, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => confirmDelete(user?.user_id)}
                  >
                    DeActivate
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="modal show fade d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to DeActivate this user?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  DaActivate
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserList;
